const DEFAULT_LINK_OPTIONS = {
  includeReport: true,
  includeCertificate: true,
  includeReceipt: true,
};

export function buildGeneratedDocumentLinks(
  jobOrderId,
  options = DEFAULT_LINK_OPTIONS
) {
  const {
    includeReport = true,
    includeCertificate = true,
    includeReceipt = true,
  } = options;

  if (!jobOrderId) {
    return {};
  }

  const baseUrl = `https://boaz-joborder-generated.s3.amazonaws.com/${jobOrderId}`;

  return {
    ...(includeReport && {
      reports_url: `${baseUrl}/${jobOrderId}_report.pdf`,
    }),
    ...(includeCertificate && {
      certificate_url: `${baseUrl}/${jobOrderId}_certificate.pdf`,
    }),
    ...(includeReceipt && {
      receipts_url: `${baseUrl}/${jobOrderId}_final_receipt.pdf`,
    }),
  };
}